import {useCustomSnackbar} from "../../useCustomSnackbar";
import {useMutation} from "@tanstack/react-query";
import {stockDumpService} from "../../../api/bhp/geomeasurement/StockDump/stockDumpService";
import {ICreateStockAndDumpInput} from "../../../api/bhp/geomeasurement/StockDump/ICreateStockAndDumpInput";
import {Strings} from "../../../Resources/Strings";


export const useCreateStockAndDump = () => {
    const {enqueueError, enqueueSuccess} = useCustomSnackbar()

    return useMutation({
        mutationFn: async (input: ICreateStockAndDumpInput) => {
            return await stockDumpService.create(input)
        },
        onSuccess: (data) => {
            enqueueSuccess(`${Strings.CreatedStockAndDump} ${data.stockDump}-${data.pit}`)
        },
        onError: (error) => {
            enqueueError(error)
        }
    })
}

